export default __webpack_public_path__ + "static/media/turkey@3x.ec487523.jpg";